import { noop } from 'lodash';
import type { Context } from 'react';
import { createContext } from 'react';

import type { Announce } from './Announcer';

export interface AnnouncerContextProps {
  readonly announce: Announce;
  readonly setActiveChildAnnouncer: (announce: Announce) => void;
  readonly clearActiveChildAnnouncer: () => void;
}

const AnnouncerContext: Context<AnnouncerContextProps> = createContext<AnnouncerContextProps>({
  announce: noop,
  setActiveChildAnnouncer: noop,
  clearActiveChildAnnouncer: noop,
});

export default AnnouncerContext;
